import { SortDirection } from '@air/api/types';

export const RECENTLY_DELETED_DEFAULT_SORT_FIELD = 'createdAt';
export const RECENTLY_DELETED_SORT_DIRECTIONS: SortDirection[] = [SortDirection.asc, SortDirection.desc];
